export default __webpack_public_path__ + "static/media/WB_ClawMachine.d788407d.gif";